var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-dashed-question",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"ph ph-plus"}),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }